module.exports = __webpack_public_path__ + "static/media/problem-background.0e7dfb77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Problem/problem-background.svg
// module id = 395
// module chunks = 0